
import { defineComponent, PropType } from 'vue'
import { CheckStatus, ScaCheckStatus } from '~/types/types'
import {
  checkStatusPillIcon,
  checkStatusPillIconColor,
  checkStatusPillLabel,
  checkStatusContainerClass,
  checkStatusTextClass
} from '~/utils/ui'

export default defineComponent({
  name: 'CheckStatusUIPill',
  props: {
    status: {
      type: String as PropType<CheckStatus | ScaCheckStatus>,
      required: true
    }
  },
  computed: {
    pillIcon(): string {
      return checkStatusPillIcon(this.status)
    },
    pillIconColor(): string {
      return checkStatusPillIconColor(this.status)
    },
    pillLabel(): string {
      return checkStatusPillLabel(this.status)
    },
    pillContainerClass(): string {
      return checkStatusContainerClass(this.status)
    },
    pillTextClass(): string {
      return checkStatusTextClass(this.status)
    }
  }
})
